import { fetch } from '@atlassian/eoc-fetch';
import { urls } from '../../../common/constants/urls';
export const getList = ({
  page
}) => {
  const limit = 20;
  const offset = (page - 1) * limit;
  const params = new URLSearchParams({
    offset: `${offset}`,
    limit: `${limit}`,
    sortBy: 'name',
    sort: 'asc'
  });
  const endpoint = `${urls.incomingCall.url()}?${params.toString()}`;
  return fetch(endpoint).then(({
    data,
    count
  }) => {
    return {
      data,
      count: Math.ceil(count / limit)
    };
  });
};
export const addIncomingCall = params => {
  return fetch(urls.incomingCall.url(), {
    method: 'POST',
    body: params
  });
};